import createHttp from '@/config/http';
import type {
	QuickBooksInvoice,
	QuickBooksInvoiceResponse,
} from '@/types/quickbooks';

// localhost:3003
// Use full URL from environment variable
const http = createHttp(import.meta.env.VITE_INVOICE_URL);

export const getQuickbooksInvoiceData = async (
	data: {
		invoiceID: string;
		clinicQBOId: string;
	}[],
): Promise<{
	items: QuickBooksInvoice[];
}> => {
	// Make the HTTP request to fetch QuickBooks invoice data
	const response = await http.post<QuickBooksInvoiceResponse>(
		'invoices/get/cart',
		{ invoiceData: data },
	);
	return {
		items: response.data.QueryResponse.Invoice as QuickBooksInvoice[],
	};
};

export const createStripeCheckoutSession = async (data: {
	invoiceRequestData: {
		invoiceNumber: string;
		clinicGUID: string;
		clinicQBOId: string;
		clinicState: string;
		bypassSurcharges: boolean;
	}[];
	userData: {
		email: string;
		name: string;
	};
	stripeSessionType: 'session' | 'link';
	paymentMethod: 'CREDIT_CARD' | 'BANK_ACCOUNT';
	// userSelectedClinics: string; //Not using right now
}): Promise<{
	message: string;
	url: string | null;
	stripeSessionType: 'session' | 'link';
}> => {
	// Make the HTTP request to fetch QuickBooks invoice data
	const response = await http.post<{
		message: string;
		url: string | null;
		stripeSessionType: 'session' | 'link';
	}>('stripe/session', { ...data });
	return response.data;
};

export const submitPaymentReportOnSuccess = async (data: {
	session_id: string;
	otp: string;
	payment_log_id: string;
}) => {
	// Destructure data
	const { session_id, otp, payment_log_id } = data;

	// Build query parameters
	const params = new URLSearchParams({
		session_id,
		otp,
		payment_log_id,
	});

	const response = await http.get(
		`stripe/addPaymentReportDataForOnSuccess?${params.toString()}`,
	);

	return response.data;
};
